import { Component, OnInit, HostListener } from '@angular/core';
import { ArticleService } from '../services/article.service'
import { from } from 'rxjs';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.less']
})
export class NewsComponent implements OnInit {

  isCollapsed = false;
  loading = false;
  article:any=[];
  notscrolly = true;
  notEmptyPost = true;
  perPage = 10;
  page = 1;
  total:any;
  getFullYear: number = new Date().getFullYear();
  
  constructor(
    private articleService: ArticleService
  ) { }

  ngOnInit() {
    this.loadInitPost();
  }

  //load the Initial 10 posts
  loadInitPost() {
    this.loading = true; 
    this.articleService.getAll(this.perPage, this.page).subscribe((res:any)=>{
      this.loading = false;
      this.total = res.data.total;
      this.article = this.article.concat(res.data.docs);
      // console.log('res',this.article);
    });
  }

  onScroll() {
    if (this.notscrolly && this.notEmptyPost) {
      this.loading = true;
      this.loadNextPost();
    }    
  }

  loadNextPost(){
    this.loading = false;
    // console.log('total', this.total);
    // console.log('this.article.length', this.article.length);
    
    if (this.article.length == this.total ) {
      this.notEmptyPost =  false;
    }

    this.page = this.page + 1;
    
    this.loadInitPost();
    this.notscrolly = true;
  }
}
